import api from './interceptor';

const BASE_URL_V2 = 'api/v2/urgent';

export default {
  // API Version 2
  createUrgentAppointment: (payload) => api.post(`${BASE_URL_V2}`, payload),
  acceptUrgentAppointment: (appointmentId) => api.post(`${BASE_URL_V2}/accept`, appointmentId),
  rejectUrgentAppointment: (appointmentId) => api.post(`${BASE_URL_V2}/reject`, appointmentId),
};
